import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { Pagination } from '../../../../../../common/pagination'
import { SCREEN } from '../../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { Table } from '../../../../../../common/table'
import { TextEllipsisStaticLine } from '../../../../../../common/textEllipsis/TextEllipsisStaticLine'
import { recommendSchema } from '../../../constants'

import {
  changeYearOfOperationPage,
  selectIsLoadingYearOfOperation,
  selectSelectedCompanyList,
  selectYearOfOperationData,
  selectYearOfOperationDataItem,
  selectYearOfOperationIds,
  selectYearOfOperationPage,
  selectYearOfOperationTotalRecords,
} from '../store/slice'
import { getRecommendationYearsOfOperation } from '../store/thunk'
import { CustomScoreCell } from './common/CustomScoreCell'
import { FirstColumnCell } from './common/FirstColumnCell'

export const YearOfOperation = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const { formatCurrency } = useFormatCurrency(SCREEN.PEER_ANALYSIS)

  const { organizationId } = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  const locale = useSelector((state) => state.i18n.locale)
  const selectedCompanyList = useSelector(selectSelectedCompanyList)
  const yearOfOperationData = useSelector(selectYearOfOperationData)
  const ids = useSelector(selectYearOfOperationIds)
  const totalRecords = useSelector(selectYearOfOperationTotalRecords)
  const isLoading = useSelector(selectIsLoadingYearOfOperation)
  const page = useSelector(selectYearOfOperationPage)

  useEffect(() => {
    dispatch(
      getRecommendationYearsOfOperation({
        OrganizationId: organizationId,
        Page: page,
        PageSize: 10,
      }),
    )
  }, [page, locale])

  const setPage = (value) => {
    dispatch(changeYearOfOperationPage(value))
  }

  return (
    <Table
      ids={ids}
      getDataFromRedux={selectYearOfOperationDataItem}
      isLoading={isLoading}
      isNoDataWithHead={true}
      autoHeightMax={450}
      schema={recommendSchema
        .filter((i) => i.colId !== 'vsicName')
        .map((item, index) => {
          if (index === 0) {
            return {
              ...item,
              render: (val) => (
                <FirstColumnCell
                  val={val}
                  selectedCompanyList={selectedCompanyList}
                  data={yearOfOperationData}
                  typeSelect={'selectOne'}
                />
              ),
              renderTh: (val) => (
                <FirstColumnCell
                  val={val}
                  selectedCompanyList={selectedCompanyList}
                  data={yearOfOperationData}
                  typeSelect={'selectAll'}
                />
              ),
            }
          }

          if (index === 1) {
            return {
              ...item,
              render: (val) => (
                <TextEllipsisStaticLine
                  zIndexTooltip={15}
                  text={val}
                  isI18n={false}
                  lineClamp={2}
                />
              ),
            }
          }

          if ([2, 3].includes(index)) {
            return {
              ...item,
              render: (value) => formatCurrency({ value }),
            }
          }

          if ([6, 5].includes(index)) {
            return {
              ...item,
              render: (val) => (
                <CustomScoreCell
                  val={val}
                  typeCell={index === 5 ? 'CREDIT_RISK' : 'PERFORMANCE'}
                />
              ),
            }
          }

          return item
        })}
      renderPagination={() => (
        <Pagination
          page={page}
          total={totalRecords}
          setPage={setPage}
          className="pt2"
          isShowPageSize={false}
        />
      )}
    />
  )
}
